import { FC } from 'react';
import { Box, Typography } from '@mui/material';
import PeopleAltIcon from '@mui/icons-material/PeopleAlt';
import { useProxyTargetMember } from './useAsUserParam';

/**
 * A sticky yellow banner shown below the PageHeader on every Account Hub
 * sub-page when a helper/HoH is editing another household member's settings.
 *
 * Reads the proxied member from useProxyTargetMember and renders nothing when
 * viewing your own account (or when the target can't be resolved).
 */
const ProxyBanner: FC = () => {
  const targetMember = useProxyTargetMember();
  const targetMemberName = targetMember
    ? `${targetMember.first_name ?? ''} ${
        targetMember.last_name ?? ''
      }`.trim() || null
    : null;

  if (!targetMemberName) {
    return null;
  }

  return (
    <Box
      sx={{
        position: 'sticky',
        top: 0,
        zIndex: 10,
        display: 'flex',
        alignItems: 'center',
        gap: 1,
        px: 2,
        py: 1,
        backgroundColor: 'warning.lighter',
        borderBottom: '1px solid',
        borderColor: 'warning.main',
      }}
    >
      <PeopleAltIcon
        sx={{ fontSize: 16, color: 'warning.darker', flexShrink: 0 }}
      />
      <Typography
        sx={{ fontSize: 13, fontWeight: 600, color: 'warning.darker' }}
      >
        Editing {targetMemberName}&apos;s settings
      </Typography>
    </Box>
  );
};

export default ProxyBanner;
